module.exports = __webpack_public_path__ + "img/join_01.36099233.png";